
import * as yup from 'yup';
import { INVALID_MESSAGES } from '../yupschema';
import PageProps from '../interfaces/pageProps';
import { isEmptyStr, trim, getFromStorage} from '../utils';
import { FORMAT_MAPPER } from './lib/govtidinput';
import { VALIDATION_REGEX } from '../regex';

export let byPageOne06 = (props:any,values:any) => {
    let res: any = {};
    const config = getFromStorage('gwp.config', true);
	if (isEmptyStr(values.firstName)) {
		res = { ...res, ...{ firstName: INVALID_MESSAGES.FIRSTNAME_IS_EMPTY } }
    }
    if (isEmptyStr(values.lastName)) {
        res = { ...res, ...{ lastName: INVALID_MESSAGES.LASTNAME_IS_EMPTY } }
    }
    if (!isEmptyStr(values.firstName) && values.firstName.trim().length > 20) {
        res = { ...res, ...{ firstName: INVALID_MESSAGES.FIRSTNAME_IS_TOO_LONG } }
    }
    if (!isEmptyStr(values.lastName) && values.lastName.trim().length > 40) {
        res = { ...res, ...{ lastName: INVALID_MESSAGES.LASTNAME_IS_TOO_LONG } }
    }
    if(isEmptyStr(values.email) && config.mfaRequiredEmailAddress && !values.proxyUser){
        res = { ...res, ...{ email: INVALID_MESSAGES.EMAIL_IS_REQUIRED } };
    }
    if (!isEmptyStr(values.email) && VALIDATION_REGEX.EMAIL.test(trim(values.email)) === false) {
        res = { ...res, ...{ email: INVALID_MESSAGES.EMAIL_IS_INVALID } };
    }

	if (isEmptyStr(values.govtID)) {
        res = { ...res, ...{ govtID: INVALID_MESSAGES.GOVT_ID_IS_EMPTY } }
    }
    if(props.regConfig.admin){
        if (isEmptyStr(values.birthDate) && props.regConfig.agentRegRequiredDOB) {
            let requiredMsg = props.getGlobalizedText(INVALID_MESSAGES.BIRTHDATE_IS_EMPTY) + " " + props.regConfig.dateformat.toLowerCase() + ".";
            
            res = { ...res, ...{ birthDate: requiredMsg } }
        }
    } else{
        if (isEmptyStr(values.birthDate) && (props.regConfig.agentRegRequiredSelfDOB && props.regConfig.agentRegRequiredDOB)) {
            let requiredMsg = props.getGlobalizedText(INVALID_MESSAGES.BIRTHDATE_IS_EMPTY) + " " + props.regConfig.dateformat.toLowerCase() + ".";
            
            res = { ...res, ...{ birthDate: requiredMsg } }
        }
    }
	if (!isEmptyStr(values.birthDate) && !isValidDate(values.birthDate)) {
        let requiredMsg = props.getGlobalizedText(INVALID_MESSAGES.BIRTHDATE_IS_INVALID) + " " + props.regConfig.dateformat.toLowerCase() + ".";
        console.log("props.regConfig.dateformat ",props.regConfig.dateformat);
        res = { ...res, ...{ birthDate: requiredMsg} }
    }
	if(!isEmptyStr(values.govtID)){
        const govID = values.govtID.replaceAll("-","");
    	let format = FORMAT_MAPPER['SSN'];
        if(govID.match(VALIDATION_REGEX.GOVT_ID) === null || isNaN(govID) ){
            res = { ...res, ...{ govtID:  props.getGlobalizedText(INVALID_MESSAGES.GOVT_ID_IS_INVALID) + " " + format.toLowerCase() + "." } };
        }                      
    }
    if (isEmptyStr(values.agentNumber)) {
        res = { ...res, ...{ agentNumber: INVALID_MESSAGES.AGENT_NUMBER_IS_REQUIRED } }
    }
    return res;
}

function isValidDate(format:any) {
    if (!/^\d\d\/\d\d\/\d\d\d\d$/.test(format)) {
      return false;
    }
    const parts = format.split('/').map((p:any) => parseInt(p, 10));
    parts[0] -= 1;
    const d = new Date(parts[2], parts[0], parts[1]);
    return d.getMonth() === parts[0] && d.getDate() === parts[1] && d.getFullYear() === parts[2];
  }